import $ from 'jquery'
import '../assets/global/scripts/dropdown'

export default {
  // bind 时 父元素还不存在
  inserted(el, binding, vnode) {
    const $el = $(el)
    const $p = $el.parent()

    $el.on('click', function() {
      $p.toggleClass('open')
    })

    $(document).on('click', function(e) {
      var isOut = true
      $(e.target).parents().each(function() {
        if (this === $p[0]) {
          isOut = false
        }
      })

      if (isOut) {
        $p.removeClass('open')
      }
    })

    $p.on('click', '[data-role=close-dropdown]', function() {
      $p.removeClass('open')
    })
  }
}
